import React from "react";
import swal from "sweetalert";

function DeleteButton({ id, deleteServicio, setServicios }) {
  function confirmDelete(id) {
    swal({
      title: "Eliminar Servicio?",
      icon: "error",
      buttons: {
        cancel: "Cancelar",
        catch: "Eliminar",
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteServicio(id).then(() => {
          swal("Servicio eliminado", {
            button: false,
            icon: "success",
            timer: "1500",
          });
          setServicios((prevState) =>
            prevState.filter((servicio) => servicio.id !== id)
          );
        });
      }
    });
  }

  return (
    <button
      className="btn btn-danger btn-sm btn-block m-1"
      onClick={() => confirmDelete(id)}
    >
      Eliminar
    </button>
  );
}

export default DeleteButton;
